/* Straight-to-checkout buying, without emptying the cart.
   1. Product pages (window.vgCartDrawer === false, set in layout/theme.liquid): "Buy Now"
      adds the item to the cart and goes to checkout, instead of the cart drawer. Products
      listed in Theme settings > Cart keep the drawer (window.vgCartDrawer === true).
   2. Every page: cart permalink links (/cart/<variant>:<qty>, the countdown bar and the
      compare buttons) do the same instead of replacing the cart.
   Whatever the customer already had in the cart stays there, so it is still in the header
   cart afterwards and goes to checkout together with the new item. An item that is already
   in the cart is not added a second time.
   Runs in the capture phase so it wins over the theme's AJAX add-to-cart handler. */
(function () {
  if (window.__vgDirectCheckout) return;
  window.__vgDirectCheckout = true;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function post(path, body) {
    return fetch(root + path, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  }

  /* getAttribute, not form.id: the form has a <select name="id">, which shadows the id property. */
  function isMainForm(form) {
    var fid = form && form.getAttribute && form.getAttribute('id');
    return !!(fid && fid.indexOf('AddToCartForm-') === 0);
  }

  /* checkout cannot load inside the theme editor frame */
  function topWindow() {
    var top = window;
    try { if (window.top && window.top.location.href) top = window.top; } catch (err) {}
    return top;
  }

  /* Instant full-screen feedback so the wait feels short and a second tap cannot do anything. */
  function overlay() {
    if (document.getElementById('vg-dc-overlay')) return;
    var st = document.createElement('style');
    st.textContent = '#vg-dc-overlay{position:fixed;inset:0;z-index:2147483000;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:16px;background:rgba(255,255,255,.94);font:600 16px/1.3 Inter,system-ui,sans-serif;color:#0E2A5C;opacity:0;animation:vgdc-in .15s forwards}' +
      '#vg-dc-overlay i{width:34px;height:34px;border-radius:50%;border:3px solid #D5E3F8;border-top-color:#2874D8;animation:vgdc-spin .7s linear infinite}' +
      '@keyframes vgdc-in{to{opacity:1}}@keyframes vgdc-spin{to{transform:rotate(360deg)}}';
    var o = document.createElement('div');
    o.id = 'vg-dc-overlay'; o.setAttribute('role', 'status'); o.innerHTML = '<i></i><span>Taking you to checkout…</span>';
    document.head.appendChild(st); document.body.appendChild(o);
  }

  /* Adds the variant unless the cart already holds it, then opens checkout. If the cart
     cannot be reached, the cart permalink still gets the customer to checkout. */
  function buy(variantId, qty) {
    window.__vgDcWent = true;
    overlay();
    (window.dataLayer = window.dataLayer || []).push({ event: 'direct_checkout', variant_id: String(variantId) });
    var top = topWindow();
    fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = (cart.items || []).some(function (item) { return String(item.variant_id) === String(variantId); });
        if (inCart) return;
        return post('cart/add.js', { items: [{ id: Number(variantId), quantity: qty }] }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
        });
      })
      .then(function () { top.location.assign(root + 'checkout'); })
      .catch(function () { top.location.assign(root + 'cart/' + encodeURIComponent(variantId) + ':' + qty); });
  }

  /* Other buy buttons (the product page "Buy now") use this too. */
  window.vgBuyNow = buy;

  function go(form) {
    var btn = form.querySelector('[type="submit"][name="add"]') || form.querySelector('[type="submit"]');
    if (form.__vgGoing || (btn && btn.disabled)) return;
    var idEl = form.elements.id;
    if (!idEl || !idEl.value) return;
    var qty = parseInt((form.elements.quantity || {}).value, 10);
    if (!qty || qty < 1) qty = 1;

    form.__vgGoing = true;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); btn.classList.add('is-loading'); }

    if (!form.querySelector('[name^="properties["], [name="selling_plan"]')) {
      buy(idEl.value, qty);
      return;
    }

    /* Line item properties / selling plans: submit the form itself (adds to the cart) and redirect to checkout. */
    window.__vgDcWent = true;
    overlay();
    (window.dataLayer = window.dataLayer || []).push({ event: 'direct_checkout', variant_id: idEl.value });
    var rt = form.querySelector('input[name="return_to"]');
    if (!rt) { rt = document.createElement('input'); rt.type = 'hidden'; rt.name = 'return_to'; form.appendChild(rt); }
    rt.value = '/checkout';
    form.target = '_top';
    HTMLFormElement.prototype.submit.call(form);
  }

  var directForms = window.vgCartDrawer === false;

  /* Click is caught first (before any theme/app click handler can open the cart drawer); submit covers Enter key and programmatic submits. */
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var link = e.target.closest('a[href]');
    if (link && !e.defaultPrevented && !e.metaKey && !e.ctrlKey && !e.shiftKey && link.target !== '_blank') {
      var url;
      try { url = new URL(link.getAttribute('href'), location.href); } catch (err) { url = null; }
      var m = url && url.origin === location.origin && url.pathname.match(/^\/cart\/(\d+):(\d+)\/?$/);
      if (m) {
        /* Only preventDefault: the link's own click handlers (analytics) still run. */
        e.preventDefault();
        if (!window.__vgDcBusy) { window.__vgDcBusy = true; buy(m[1], parseInt(m[2], 10) || 1); }
        return;
      }
    }
    if (!directForms) return;
    var btn = e.target.closest('button[type="submit"][name="add"], [id^="AddToCart-"]');
    if (!btn) return;
    var form = btn.form || btn.closest('form');
    if (!isMainForm(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    go(form);
  }, true);

  document.addEventListener('submit', function (e) {
    if (!directForms) return;
    var form = e.target;
    if (!isMainForm(form)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    go(form);
  }, true);

  /* Back button from checkout (bfcache): the page comes back as it was before the item was
     added, so reload it once for the right header cart count and drawer contents. */
  window.addEventListener('pageshow', function (e) {
    if (e.persisted && window.__vgDcWent) window.location.reload();
  });
})();
